import React, { lazy, Suspense } from 'react'
import type { ComponentProps } from 'react'

// SnoozePicker drags antd DatePicker (~240 KB raw rc-picker). Wrap it in a
// thin lazy boundary so the Floria assistant panel doesn't pay for it
// just because it sits in the eager app shell.
const Inner = lazy(() =>
  import('./SnoozePicker').then((m) => ({ default: m.SnoozePicker })),
)

export type SnoozePickerProps = ComponentProps<typeof Inner>

export const SnoozePicker: React.FC<SnoozePickerProps> = (props) => (
  <Suspense fallback={null}>
    <Inner {...props} />
  </Suspense>
)
